module.exports = __webpack_public_path__ + "img/bag-5.122c29ba.jpg";